
import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import React, { useCallback, useEffect, useRef, useState } from "react";
// import { IMaskInput } from 'react-imask';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { UtilidadeService } from "../services/api/utilidades/UtilidadesService";


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}                
                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
            //prefix="R$"
            />
        );
    },
);

interface State {
    textmask: string;
    numberformat: string;
}

type TVTextFieldProps = TextFieldProps & {
    prefix?: string;
    name: string;
    typeMask?: string;
    maxLength?: number;
}

export const VTextMaskCustom: React.FC<TVTextFieldProps> = ({ name, typeMask, maxLength, ...rest }) => {
    const inputRef = useRef(null);
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue || "");

    useEffect(() => {


        registerField({
            name: fieldName,
            ref: inputRef,
            getValue: () => value,
            setValue: (_, newValue) => {
                setValue(newValue);
            },
        });

    }, [registerField, fieldName, value])

    const handleKeyUp = useCallback((e: any) => {

        let value = e.target.value;

        setValue(Number(value));


    }, []);


    return (
        <TextField
            ref={inputRef}
            defaultValue={defaultValue}
            {...rest}
            error={!!error}
            helperText={error}
            type="text"
            value={value}
            size={UtilidadeService.isMobile() ? "small" : "medium"}
            onChange={(e) => { setValue(e.target.value); rest.onChange?.(e); }}

            slotProps={{
                input: {
                    inputComponent: NumericFormatCustom as any,
                },
                htmlInput: {
                    style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 },
                },
                inputLabel: {
                    style: {
                        fontSize: UtilidadeService.isMobile() ? 14 : 16
                    }
                }
            }}


        />
    );
};

